import { useQuery, UseQueryResult } from 'react-query';
import { wgApi } from '../../../../../app/src/features/api/wgApi';
import { request } from '../../../../../common/src/legacy/services/httpSessionService';
import { Party } from '../../../types';

export const getPartyById = async (partyId: string): Promise<Party> => {
  const { data, isError } = await wgApi.get<Party>(`v1/api/parties/${partyId}`);
  if (isError) throw new Error();
  return data;
};

/**
 * @deprecated use getPartyById instead
 */
export const getPartyByIdLegacy = async (
  partyId: string,
): Promise<[Party, number]> => {
  const path = `v1/api/parties/${partyId}`;
  const [resp, status] = await request({ path });

  return [resp, status];
};

export const getUsePartyKey = (partyId?: string): (string | undefined)[] => [
  'party',
  partyId,
];

export const useParty = (partyId?: string): UseQueryResult<Party> => {
  return useQuery<Party>(
    getUsePartyKey(partyId),
    () => getPartyById(partyId!),
    {
      refetchOnWindowFocus: false,
      enabled: !!partyId,
    },
  );
};
